import { useMutation } from "@tanstack/react-query";
import { instance } from "api/apiBase";
import { toast } from "react-toastify";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { getErrorMessage } from "utils/error";
import { Step } from "../../types";

export const NoFinancingOption = ({
  applicantId,
  applicationId,
  step,
  onDeclined
}: {
  applicantId: number;
  applicationId: number;
  step: Step;
  onDeclined: () => void;
}) => {
  const verificationId = step.id;

  const declineFinancing = useMutation({
    mutationKey: [
      "BOOM_FINANCE_DECLINE_FINANCING",
      "CREATE",
      applicationId,
      verificationId
    ],
    mutationFn: () =>
      instance.post(
        `/portal/v1/applications/${applicationId}/verifications/${verificationId}/boom_finance/decline_financing`,
        { applicant_id: applicantId }
      ),
    onSuccess: onDeclined,
    onError: (error) =>
      toast.error(getErrorMessage(error) || "Could not record the opt-out")
  });

  return (
    <div className="border-t border-alpha-100 bg-white">
      <div className="w-full flex justify-center px-6 py-4">
        <Button
          size={ButtonSize.LG}
          variant={ButtonVariant.BASE}
          disabled={declineFinancing.isPending}
          onClick={() => declineFinancing.mutate()}
          className="max-w-[550px] w-full"
        >
          Applicant doesn&apos;t need financing
        </Button>
      </div>
    </div>
  );
};
